export const userCamelCase = (shitUser) => {
    return {
        email: shitUser.Email,
        image: shitUser.Icon,
        id: shitUser.Id,
        name: shitUser.Name,
        phone: shitUser.Phone,
        token: shitUser.datacontent
    }
}